import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { IUnidade } from '../../model/unidade.model';

@Injectable()
export class UnidadeService extends EntityService<IUnidade> {
  constructor(protected configService: ConfigService) {
    super({
      baseEntityEndPoint: 'unidade',
      urlBackend: configService.backendURL
    });
  }
}
